export type SportJsonInput = Record<string, SportEntry>;

export type SportEntry = {
  name: string;
  cuiSportId: string;
  alternateNames?: string[];
  metadata?: Record<string, unknown>;
};

export type SportsMap = Record<string, SportEntry>;

/**
 * Parses raw sport.json into a lookup map keyed by name + alternateNames.
 * Used by both StyleDictionary (build-time) and client (runtime).
 */
export function parseSportData(input: SportJsonInput): SportsMap {
  const map: SportsMap = {};
  if (!input || typeof input !== "object") return map;

  for (const [, sport] of Object.entries(input)) {
    if (!sport?.name) continue;
    map[sport.name] = sport;
    for (const alt of sport.alternateNames || []) {
      map[alt] = sport;
    }
  }

  return map;
}
